<template>
<div id="app">
      <div class="ibox float-e-margins set-ibox">
          <div class="ibox-title">
              <h5>修改儿童记录</h5>
          </div>
          <div class="ibox-content set-ibox-content">
              <el-form  class="form-horizontal m-t" :rules="validation" ref="formInline" :model="formInline" label-width="100px" label-position="right">
                  <el-form-item label="身份证号码：" prop="idCard">
                      <el-col :span="18" style="width:84%">
                          <el-input  v-model="formInline.idCard" placeholder="请输入身份证" maxlength="18"></el-input>
                      </el-col>
                      <el-col :span="1" :offset="1"  style="text-align:right">
                          <el-button type="primary" @click="checkIDCard(formInline.idCard)" :span="5" :offset="1">查重</el-button>
                      </el-col>
                  </el-form-item>
                  <el-row :span="24" type="flex">
                      <el-form-item label="姓名：" prop="childName" :span="12" style="width:50%">
                          <el-col>
                              <el-input  v-model="formInline.childName" placeholder="请输入姓名" maxlength="8"></el-input>
                          </el-col>
                      </el-form-item>

                      <el-form-item label="性别：" prop="sex" :span="9"  :offset="3"  style="width:50%">
                          <el-col>
                              <el-select v-model="formInline.sex" placeholder="请选择性别" style="width:100%">
                                  <el-option key="男" label="男" value="男"></el-option>
                                  <el-option key="女" label="女" value="女"></el-option>
                              </el-select>
                          </el-col>
                      </el-form-item>
                  </el-row>
                  <el-form-item label="生日：" prop="birthday">
                      <el-col :span="24">
                          <el-date-picker type="date" placeholder="选择日期" value-format='yyyy-MM-dd' v-model="formInline.birthday" style="width:100%"></el-date-picker>
                      </el-col>
                  </el-form-item>

                  <el-form-item label="所属幼儿园：" prop="kindOrgID">
                      <el-col :span="24">
                          <el-select v-model="formInline.kindOrgName" filterable placeholder="请选择幼儿园" style="width:100%" @change="changeKind()">
                              <el-option v-for="item in selectKind" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                          </el-select>
                      </el-col>
                  </el-form-item>

                  <el-form-item label="联系人：">
                      <el-col :span="24">
                          <el-input  v-model="formInline.relation" placeholder="请输入联系人姓名" maxlength="18"></el-input>
                      </el-col>
                  </el-form-item>

                  <el-form-item label="手机号码：" prop="relationPhone">
                      <el-col :span="24">
                          <el-input  v-model="formInline.relationPhone" placeholder="请输入联系人手机号码" maxlength="18"></el-input>
                      </el-col>
                  </el-form-item>
                  <el-form-item label="地址：" prop="provinceID" >
                      <el-col :span="8">
                          <el-select v-model="formInline.provinceID" placeholder="请选择省" v-on:change="onChangePro(formInline.provinceID)">
                              <el-option v-for="item in selectpro" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                          </el-select>
                      </el-col>
                      <el-col :span="7" :offset="1">
                          <el-select v-model="formInline.cityID" placeholder="请选择市" v-on:change="onChangeCity(formInline.cityID)">
                              <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                          </el-select>
                      </el-col>
                      <el-col :span="7" :offset="1">
                          <el-select v-model="formInline.countryID" placeholder="请选择区">
                              <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                          </el-select>
                      </el-col>
                  </el-form-item>

                  <el-form-item>
                      <el-col :span="24">
                          <el-input  v-model="formInline.street" placeholder="请输入地址" maxlength="250"></el-input>
                      </el-col>
                  </el-form-item>
                  <el-form-item>
                      <el-button class="btn-primary" @click="editTo()">确定</el-button>
                      <el-button class="btn-default" @click="close()">取消</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </div>
</div>

</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import config from '../../com/config'
import api from '../../com/ajax' // 改成对应的路径
// import AreaSelect from '@/components/utils/AreaSelect.vue'

export default {
  name: 'app',
  data () {
        /**
         * 校验规则
         */
        // 身份证校验
    var v_idCards = (rule, value, callback) => {
      if (value && !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
        callback(new Error('身份证号不合法'))
      }
      callback()
    }

        // 姓名校验
        // var v_realName = (rule, value, callback) => {
        //     if (!/^[\u4E00-\u9FA5]{2,8}$/.test(value))  {
        //         callback(new Error('姓名必须为2-8位汉字'));
        //     }
        //     callback();
        // };

        // 对象属性
    return {
      formInline: {
        idCard: '', // 身份证号
        childName: '', // 姓名
        sex: '', // 性别
        birthday: '', // 生日
        kindOrgID: '', // 幼儿园id
        kindOrgName: '', // 幼儿园名字
        relation: '', // 联系人姓名
        relationPhone: '', // 联系电话
        provinceID: '', // 联系省
        cityID: '', // 联系市
        countryID: '', // 联系区县
        street: ''// 地址
      },
      editID: '',
      selectKind: [], // 幼所属幼儿园集合
      selectpro: [], // 省集合
      selectcity: [], // 市集合
      selectarea: [], // 区县集合
      item: [],
      getParentID: '',
      getCityID: '',
      getID: '',
      getCID: '',
      validation: {
        idCard: [
                     { validator: v_idCards, trigger: 'blur' }
        ],
        childName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                    // {  validator: v_realName, trigger: 'change' }
        ],
        sex: [
                    { required: true, message: '请选择性别', trigger: 'blur' },
                    { message: '请选择性别', trigger: 'change' }
        ],
        birthday: [
                    { required: true, message: '请选择日期', trigger: 'change' },
                    { message: '请选择日期', trigger: 'change' }
        ],
        relationPhone: [
                    { required: false, message: '请输入手机号码', trigger: 'blur' },
                    { pattern: /^\d{11}$/, message: '手机号只能是11位数字', trigger: 'blur'}
        ]
      }

    }
  },
  methods: {
    editTo () { // 确定
      var self = this
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          var param = this.formInline
          param.childID = this.editID
                    // param.birthday=this.birth;
          api.post(config.host + 'child/updateChild.do', param).then((response) => {
            if (response.success === true) {
              self.$message.success('修改成功')

              self.$router.push({path: '/childsmgr'})

              self.$emit('close', false, true)
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    changeKind () {
      let that = this
      that.selectKind.forEach(function (item, index) {
        if (that.formInline.kindOrgName === item.orgKindID) {
          that.formInline.kindOrgID = item.orgKindID
          that.formInline.kindOrgName = item.fullName
        }
      })
    },
    close () { // 取消
      var list = this.formInline
      for (var i in list) {
        list[i] = ''
      };
      this.$refs.formInline.resetFields()
      this.$emit('close', false, false)
    },
    onChangePro (parentID) { // 省市区联动
      let self = this
      if (parentID === '' || parentID === undefined) {
        self.getParentID = 0
      } else {
        self.getParentID = self.formInline.provinceID
      }
      if (self.getParentID === '' || self.getParentID === undefined) {
        self.getParentID = 0
      }
      if (self.getParentID !== 'undefined') {
        api.post(config.host + 'common/getAreasList.do', { 'parentID': self.getParentID }).then((response) => {
          if (response.success === true) {
            self.selectcity = response.body.list
            self.formInline.countryID = ''
            if (self.item.cityID === '') {
              self.formInline.cityID = ''
            } else {
              self.formInline.cityID = self.item.cityID + ''
              self.item.cityID = ''
            }
            // self.selectcity.splice(0, 0, { 'id': '', 'name': '全部' })
          }
        })
      }
    },
    onChangeCity (parentID) { // 省市区联动
      let self = this
      if (parentID === '' || parentID === undefined) {
        self.getCityID = 0
      } else {
        self.getCityID = self.formInline.cityID
      }
      if (self.getCityID === '' || self.getCityID === undefined) {
        self.getCityID = 0
      }
      if (self.getCityID !== 'undefined') {
        api.post(config.host + 'common/getAreasList.do', { 'parentID': self.getCityID }).then((response) => {
          if (response.success === true) {
            self.selectarea = response.body.list
            if (self.item.countryID === '') {
              self.formInline.countryID = ''
            } else {
              self.formInline.countryID = self.item.countryID
              self.item.countryID = ''
            }
          }
        })
      }
    },
    checkIDCard (CardID) { // 身份证查重
      let that = this
      if (CardID) {
        api.post(config.host + '/child/checkIDCard.do', {'IDCard': CardID}).then((data) => {
          if (data.success === true) {
            that.$message.success(data.msg)
          } else {
            that.$message.error(data.msg)
          }
        })
      }
    },
    loadInit () { // 初始化加载页面详情内容
      let self = this
      self.editID = self.$route.params.id
      api.post(config.host + 'child/getChildByID.do', {'childID': self.editID}).then((data) => {
        if (data.success == true) {
          self.item = data.body.list
          self.formInline.idCard = self.item.idCard
          self.formInline.childName = self.item.childName
          self.formInline.sex = self.item.sex
          self.formInline.kindOrgID = self.item.kindOrgID
          self.formInline.birthday = self.item.birthday
          self.formInline.kindOrgName = self.item.kindOrgName
          self.formInline.relation = self.item.relation
          self.formInline.relationPhone = self.item.relationPhone
          self.formInline.street = self.item.street
          // 加载省市区各列表
          api.post(config.host + 'common/getAreasList.do', {parentID: 0}).then((data) => {
            if (data.success == true) {
              self.selectpro = data.body.list
              if (self.item.provinceID != '' && self.item.provinceID != undefined) {
                self.formInline.provinceID = self.item.provinceID + ''
              } else {
                self.formInline.provinceID = ''
              }
            }
          })
        }
      })
            // 初始化加载各渲染部件的数据
            // 加载幼儿园列表
      api.post(config.host + 'orgkind/getGardenListByOrganId.do').then((data) => {
        if (data.success == true) {
          self.selectKind = data.body.list
        }
      })
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.loadInit()
      },
      deep: true
    },
    'formInline.provinceID': function (val) {
      var self = this
      self.$nextTick(function () {
        if (val === '' || val === undefined) {
          self.getID = 0
        } else {
          self.getID = val
        }
        if (self.getID !== 'undefined') { self.onChangePro(self.getID) }
      })
    },
    'formInline.cityID': function (val) {
      var self = this
      self.$nextTick(function () {
        if (val === '' || val === undefined) {
          self.getCID = 0
        } else {
          self.getCID = val
        }
        if (self.getCID !== 'undefined') { self.onChangeCity(self.getCID) }
      })
    }
  },
  created: function () {
    this.loadInit()
  }
}
</script>
<style>
     .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 27px 0px;
    }
    .set-ibox{
        margin-bottom:0;
    }
    .el-form-item {
        margin-bottom: 16px;
    }
    .set-ibox-content {
        padding: 5px 20px 8px 20px;
    }
</style>
<style scoped>
    .el-dialog {
        min-width: 70%;
    }
</style>


// WEBPACK FOOTER //
// src/components/childmgr/childsmgrEdit.vue